import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/logo.png";

const NotFoundPage: React.FC = () => {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-slate-950 px-4 text-center">
      <img src={logo} alt="IntelliWarrior" className="mb-8 h-20 w-20 object-contain" />
      <p className="text-sm font-semibold uppercase tracking-widest text-cyan-400/80">404</p>
      <h1 className="mt-2 text-3xl font-bold text-white">Page not found</h1>
      <p className="mt-3 max-w-md text-sm text-slate-400">
        The page you are looking for does not exist or was moved.
      </p>
      <Link
        to="/"
        className="mt-8 inline-flex rounded-xl bg-gradient-to-r from-blue-500 to-cyan-400 px-6 py-3 text-sm font-semibold text-slate-950 shadow-lg shadow-cyan-500/25 hover:brightness-110"
      >
        Back to Home
      </Link>
    </div>
  );
};

export default NotFoundPage;
